import { render, staticRenderFns } from "./WealDetail.vue?vue&type=template&id=1fd2dc7e&"
import script from "./WealDetail.vue?vue&type=script&lang=ts&"
export * from "./WealDetail.vue?vue&type=script&lang=ts&"
import style0 from "./WealDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports